export default "__VITE_ASSET__BjNrHUvk__"